import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Eye, X } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function ImpersonationBanner() {
  const { user, business, refresh } = useAuth();
  const nav = useNavigate();

  if (!user?.impersonating) return null;

  const exit = async () => {
    try {
      const { data } = await api.post("/superadmin/exit-impersonation");
      if (data.token) localStorage.setItem("lf_token", data.token);
      await refresh();
      toast.success("Exited impersonation");
      nav("/app/superadmin");
    } catch { toast.error("Failed to exit"); }
  };

  const name = business?.business_name || user?.impersonating_business_name || "another business";
  return (
    <div className="sticky top-0 z-50 bg-[#FF5A00] text-white px-4 py-2 flex items-center justify-between border-b-2 border-[#B33F00]" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="w-4 h-4"/>
        <span>Viewing as <b>{name}</b> · Any changes you make happen inside this business.</span>
      </div>
      <button
        onClick={exit}
        className="flex items-center gap-1 text-xs px-3 py-1 rounded bg-white text-[#FF5A00] hover:bg-zinc-100 font-medium"
        data-testid="impersonation-exit-btn"
      >
        <X className="w-3 h-3"/> Exit
      </button>
    </div>
  );
}
